<template>
  <VDataGridV2
    :loader="dataLoader"
    sticky
    entity-type="budgetPrice"
    clickable
    :context-menu="BudgetPricesService.contextMenu"
    @row:dblclick="openBudgetPriceCard"
  >

    <VDataGridColumnV2
      id="code"
      label="Артикул"
      width="120px"
      content-align="center"
      filterable
      filter-send-name="code"
      :filter-props="{ placeholder: 'Введите артикул', clearable: true }"
    >
      <template #default="{ row }">
        {{ row.code || '--' }}
      </template>
    </VDataGridColumnV2>

    <VDataGridColumnV2
      id="product"
      label="Название продукта"
      content-class="ellipsis"
      width="400px"
      filterable
      filter-send-name="pattern"
      :filter-props="{ placeholder: 'Введите название товара', clearable: true }"
    >
      <template #default="{ row }">
        {{ row.name }}
      </template>
    </VDataGridColumnV2>

    <VDataGridColumnV2
      id="price"
      label="Цена"
      width="150px"
      content-align="right"
      header-class="nowrap"
    >
      <template #default="{ row }">
        <template v-if="row.actualBudgetPrice !== null">
          <div class="nowrap">{{ row.actualBudgetPrice.price.format(row.actualBudgetPrice.currency, row.unit) }}</div>
          <div class="nowrap description">с {{ row.actualBudgetPrice.validityPeriod.start?.format() }}</div>
        </template>

        <div v-for="futureBudgetPrice in row.futureBudgetPrices" :key="futureBudgetPrice.id" class="nowrap description">
          с {{ futureBudgetPrice.validityPeriod.start?.format() }} — {{ futureBudgetPrice.price.format(futureBudgetPrice.currency, row.unit) }}
        </div>
      </template>
    </VDataGridColumnV2>

    <VDataGridColumnV2
      id="priceCalculated"
      label="Цена рассчитанная"
      width="150px"
      content-align="right"
      header-class="nowrap"
    >
      <template #default="{ row }">
        {{ row.actualBudgetPrice?.price.formatInDisplayCurrency(row.actualBudgetPrice.currency, rateDate, row.unit) ?? '--' }}
      </template>
    </VDataGridColumnV2>

    <VDataGridColumnV2
      id="optimalPurchaseQty"
      label="Объём закупки"
      width="200px"
      content-align="right"
      header-class="nowrap"
    >
      <template #default="{ row }">
        {{ row.actualBudgetPrice?.optimalPurchaseQty?.formatSmart(row.unit) ?? '--' }}
      </template>
    </VDataGridColumnV2>

    <VDataGridColumnV2
      id="productionRequiredPackageVolume"
      label="Требуемая фасовка"
      width="200px"
      content-align="right"
      header-class="nowrap"
    >
      <template #default="{ row }">
        {{ row.productionRequiredPackageVolume?.formatSmart(row.unit) ?? '--' }}
      </template>
    </VDataGridColumnV2>

    <!-- комментирую кнопку, так как пока не выявлено целесообразности
    создания бюджетной цены из реестра бюджетных цен.
    <VDataGridActionBarV2>
      <template #default>
        <VButton @click="openBudgetPriceCard">
          Создать бюджетную цену
        </VButton>
      </template>
    </VDataGridActionBarV2>-->
  </VDataGridV2>
</template>

<script lang="ts">
import DataGridLoader      from "@/lib/components/VDataGridV2/DataGridLoader";
import BudgetPricesService from "@/domains/BudgetPrices/BudgetPricesService";
import type Product      from "@/domains/Products/Product";
import DateSimple          from "@/core/types/DateSimple";

export default defineComponent({
  name: "BudgetPricesRegistry",

  setup() {
    return {
      BudgetPricesService,
    }
  },

  data() {
    return {
      dataLoader: new DataGridLoader(BudgetPricesService.getListPaginated),
      rateDate: DateSimple.today(),
    }
  },

  methods: {
    async openBudgetPriceCard(product: Product): Promise<void> {
      if (await BudgetPricesService.showBudgetPriceCard(product) === true) {
        await this.dataLoader.refresh();
      }
    }
  },
});
</script>